function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-cond-assign */

/* eslint-disable no-plusplus */
import { MenuItem } from 'prosemirror-menu';
import { toggleMark, setBlockType } from 'prosemirror-commands';
import { undo, redo } from 'prosemirror-history';
import { wrapInList } from 'prosemirror-schema-list';
import { openPrompt } from '../prompt';
import { TextField } from '../TextField';
import { markActive } from '../utils';
import { BoldIcon, ItalicsIcon, SuperscriptIcon, CodeIcon, UndoIcon, RedoIcon, LinkIcon, Heading3Icon, Heading2Icon, Heading1Icon, TextNumberListIcon, BulletListIcon, ImageUploadIcon } from '../icons.js'; // Helpers to create specific types of items

function cmdItem(cmd, options) {
  var passedOptions = {
    label: options.title,
    run: cmd
  };
  Object.keys(options).reduce(function (acc, optionKey) {
    acc[optionKey] = options[optionKey];
    return acc;
  }, passedOptions);
  if ((!options.enable || options.enable === true) && !options.select) passedOptions[options.enable ? 'enable' : 'select'] = function (state) {
    return cmd(state);
  };
  return new MenuItem(passedOptions);
}

function blockTypeIsActive(state, type, attrs) {
  var $from = state.selection.$from;
  var wrapperDepth;
  var currentDepth = $from.depth;

  var _loop = function _loop() {
    var currentNodeAtDepth = $from.node(currentDepth);

    var comparisonAttrs = _objectSpread({}, attrs);

    if (currentNodeAtDepth.attrs.level) {
      comparisonAttrs.level = currentNodeAtDepth.attrs.level;
    }

    var isType = type.name === currentNodeAtDepth.type.name;
    var hasAttrs = Object.keys(attrs).reduce(function (prev, curr) {
      if (attrs[curr] !== currentNodeAtDepth.attrs[curr]) {
        return false;
      }

      return prev;
    }, true);

    if (isType && hasAttrs) {
      wrapperDepth = currentDepth;
    }

    currentDepth -= 1;
  };

  while (currentDepth > 0) {
    _loop();
  } // return wrapperDepth !== undefined;


  return wrapperDepth;
}

var toggleBlockType = function toggleBlockType(type, attrs) {
  return function (state, dispatch) {
    var isActive = blockTypeIsActive(state, type, attrs);
    var newNodeType = isActive ? state.schema.nodes.paragraph : type;
    var setBlockFunction = setBlockType(newNodeType, attrs);
    return setBlockFunction(state, dispatch);
  };
};

function markItem(markType, options) {
  var passedOptions = {
    active: function active(state) {
      return markActive(state, markType);
    },
    enable: true
  };
  Object.keys(options).reduce(function (acc, optionKey) {
    acc[optionKey] = options[optionKey];
    return acc;
  }, passedOptions);
  return cmdItem(toggleMark(markType), passedOptions);
}

function linkItem(markType) {
  return new MenuItem({
    title: 'Add or remove link',
    icon: LinkIcon,
    active: function active(state) {
      return markActive(state, markType);
    },
    enable: function enable(state) {
      return !state.selection.empty;
    },
    run: function run(state, dispatch, view) {
      if (markActive(state, markType)) {
        toggleMark(markType)(state, dispatch);
        return true;
      }

      openPrompt({
        title: 'Create a link',
        fields: {
          href: new TextField({
            label: 'https://example.com',
            class: 'small',
            required: true
          })
        },
        callback: function callback(attrs) {
          toggleMark(markType, attrs)(view.state, view.dispatch);
          view.focus();
        }
      });
      return false;
    }
  });
}

function headerItem(nodeType, options) {
  var _options$level = options.level,
      level = _options$level === void 0 ? 1 : _options$level;
  return new MenuItem({
    title: "Heading ".concat(level),
    icon: options.icon,
    active: function active(state) {
      return blockTypeIsActive(state, nodeType, {
        level: level
      });
    },
    enable: function enable() {
      return true;
    },
    run: function run(state, dispatch, view) {
      if (blockTypeIsActive(state, nodeType, {
        level: level
      })) {
        toggleBlockType(nodeType, {
          level: level
        })(state, dispatch);
        return true;
      }

      toggleBlockType(nodeType, {
        level: level
      })(view.state, view.dispatch);
      view.focus();
      return false;
    }
  });
}

function imageUploadItem(nodeType, onFileUpload) {
  return new MenuItem({
    title: 'Upload image',
    icon: ImageUploadIcon,
    enable: function enable() {
      return true;
    },
    run: function run() {
      onFileUpload();
      return true;
    }
  });
}

function wrapListItem(nodeType, options) {
  return cmdItem(wrapInList(nodeType, options.attrs), options);
}

export function buildArticleEditorMenu(schema, onFileUpload) {
  var r = {
    toggleStrong: markItem(schema.marks.strong, {
      title: 'Toggle strong style',
      icon: BoldIcon
    }),
    toggleEm: markItem(schema.marks.em, {
      title: 'Toggle emphasis',
      icon: ItalicsIcon
    }),
    toggleSuper: markItem(schema.marks.superscript, {
      title: 'Toggle Superscript',
      icon: SuperscriptIcon
    }),
    toggleCode: markItem(schema.marks.code, {
      title: 'Toggle code font',
      icon: CodeIcon
    }),
    toggleLink: linkItem(schema.marks.link),
    wrapBulletList: wrapListItem(schema.nodes.bullet_list, {
      title: 'Wrap in bullet list',
      icon: BulletListIcon
    }),
    wrapOrderedList: wrapListItem(schema.nodes.ordered_list, {
      title: 'Wrap in ordered list',
      icon: TextNumberListIcon
    }),
    toggleH1: headerItem(schema.nodes.heading, {
      level: 1,
      title: 'Toggle code font',
      icon: Heading1Icon
    }),
    toggleH2: headerItem(schema.nodes.heading, {
      level: 2,
      title: 'Toggle code font',
      icon: Heading2Icon
    }),
    toggleH3: headerItem(schema.nodes.heading, {
      level: 3,
      title: 'Toggle code font',
      icon: Heading3Icon
    }),
    undoItem: new MenuItem({
      title: 'Undo last change',
      run: undo,
      enable: function enable(state) {
        return undo(state);
      },
      icon: UndoIcon
    }),
    redoItem: new MenuItem({
      title: 'Redo last undone change',
      run: redo,
      enable: function enable(state) {
        return redo(state);
      },
      icon: RedoIcon
    }),
    imageUploadItem: imageUploadItem(schema.nodes.image, onFileUpload)
  };

  var cut = function cut(arr) {
    return arr.filter(function (x) {
      return x;
    });
  };

  r.inlineMenu = [cut([r.toggleStrong, r.toggleEm, r.toggleCode, r.toggleLink])];
  r.blockMenu = [cut([r.toggleH1, r.toggleH2, r.toggleH3, r.wrapBulletList, r.wrapOrderedList, r.imageUploadItem])];
  r.fullMenu = r.inlineMenu.concat([[r.undoItem, r.redoItem]], r.blockMenu);
  return r;
}